export default {"src":"/_next/static/media/app-store_badge_en.181ec940.svg","height":40,"width":120};